var Mn = require('backbone.marionette');
require('slick-carousel');

module.exports = Mn.Behavior.extend({
    ui: {
        'play': '[data-video-play]',
        'expand': '[data-video-expand]',
        'videoContainer': '[data-video]'
    },
    events: {
        'click @ui.play': 'videoTogglePlay',
        'click @ui.expand': 'videoFullscreen'
    },
    videoTogglePlay: function(e) {
        e.preventDefault();

        var video = document.querySelectorAll('[data-video-source]')[0];

        if ( this.ui.videoContainer.hasClass('playing') ) {
            video.pause();
            this.ui.videoContainer.removeClass('playing');
        } else {
            video.play();
            this.ui.videoContainer.addClass('playing');
        }
    },
    videoFullscreen: function(e) {
        e.preventDefault();

        var video = document.querySelectorAll('[data-video-source]')[0];

        if (video.requestFullscreen) {
            video.requestFullscreen();
        } else if (video.msRequestFullscreen) {
            video.msRequestFullscreen();
        } else if (video.mozRequestFullScreen) {
            video.mozRequestFullScreen();
        } else if (video.webkitRequestFullscreen) {
            video.webkitRequestFullscreen();
        }
    }
});



//////////////////
// WEBPACK FOOTER
// ./resources/assets/site/scripts/behaviors/Video.js
// module id = 230
// module chunks = 3